<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="
					selectedUrl
						? `transaction/parent/${inputs.id}`
						: `transaction/parent`
				"
			>
				<div class="form-group row align-items-center">
					<label for="inputs_name" class="col-sm-3 mb-0">
						Name
					</label>
					<app-input
						id="inputs_name"
						class="col-sm-9"
						type="text"
						v-model="inputs.name"
						placeholder="Name"
						:required="true"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_is_mother" class="col-sm-3 mb-0">
						Is Mother
					</label>
					<app-input
						id="inputs_is_mother"
						class="col-sm-9"
						type="radio"
						v-model="inputs.is_mother"
						:list="isMotherLists"
						placeholder="Chinese Lesson at School"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_contact" class="col-sm-3 mb-0">
						Contact
					</label>
					<app-input
						id="inputs_contact"
						class="col-sm-9"
						type="number"
						v-model="inputs.contact"
						placeholder="Contact"
						:required="true"
					/>
				</div>

				<div class="form-group row align-items-center">
                    <label for="inputs_is_whatsapp_same_as_contact" class="col-sm-3 mb-0">
                        &nbsp;
                    </label>
                    <div class="col-sm-8">
                        <app-input id="inputs_is_whatsapp_same_as_contact" :list-value-field="'Is WhatsApp Same As Contact'" type="single-checkbox" v-model="sameAsContactNumber" :disabled="inputs.whatsapp == inputs.contact" />
                    </div>
                </div>

				<div class="form-group row align-items-center">
					<label for="inputs_whatsapp" class="col-sm-3 mb-0">
						WhatsApp
					</label>
					<app-input
						id="inputs_whatsapp"
						class="col-sm-9"
						type="number"
						v-model="inputs.whatsapp"
						placeholder="WhatsApp"
						:required="true"
					/>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../Mixins/ModalMixin";

export default {
	name: "ParentListForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
	},
	data() {
		return {
			preloader: false,
			modalId: this.formId,
			modalTitle: this.$t("add"),
			inputs: {},
			sameAsContactNumber: false,
			isMotherLists: [
				{ id: 1, value: 'Yes'},
				{ id: 0, value: 'No'},
			]
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
	},
	methods: {
		submit() {
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			this.inputs = response.data;
			this.sameAsContactNumber = (this.inputs.is_whatsapp_same_as_contact == 1) || (this.inputs.whatsapp == this.inputs.contact) ? true : false;
			this.preloader = false;
		},
	},
	watch: {
		isMother: {
			handler: function (val) {
				this.inputs.is_mother = val;
			},
			deep: true,
		},
		sameAsContactNumber: {
			handler: function (val) {
				this.inputs.is_whatsapp_same_as_contact = val;
				if (val) {
					this.inputs.whatsapp = this.inputs.contact;
				}
			},
			deep: true,
		},
		"inputs.whatsapp": {
			handler: function (val) {
				if (this.inputs.whatsapp == this.inputs.contact) {
					this.sameAsContactNumber = true;
				} else {
					this.sameAsContactNumber = false;
				}
			},
			deep: true,
		},
	},
};
</script>
